import { NamespacedImageKeys } from '@betty/moonlight';

export type ResponsibleGamblingItem = {
  imgSrc: NamespacedImageKeys
  title: string
  description: string
}


export type AboutUsItemType = ResponsibleGamblingItem & { image: string };

export const aboutUsItems: AboutUsItemType[] = [
  {
    imgSrc: 'landingPage.messages',
    title: '24/7 Human Support',
    description:
      'Have feedback? We’re here for it. Our support team’s on standby 24/7—no bots, just real people.',
    image: '',
  },
  {
    imgSrc: 'landingPage.lock',
    title: 'Safe & Secure',
    description:
      'Betty is fully licensed and regulated by the AGCO and managed by iGaming Ontario. We offer Interac® and card payments to give you the smoothest gaming experience.',
    image: '',
  },
  {
    imgSrc: 'landingPage.slot',
    title: 'Responsible Gaming',
    description:
      'At Betty, you have full control of how much you want to play. We offer deposit limits, loss limits, playtime limits, timeouts, and self-exclusion to help you game responsibly.',
    image: '',
  },
];
